import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { encodeBase64UrlSafe } from '../../../Utils/utils';

/**
 * Abre no sistema uma tela sugerida pelo chat.
 *
 * Navega para /iframe/{departamento}/{submenu} -- exatamente o que o menu
 * lateral faz ao clicar num item (o Link de ListMenuItems monta essa mesma
 * rota). Quem resolve o submenu e chama navegarTela e o proprio Iframe.jsx ao
 * montar ali.
 *
 * Chamar navegarTela daqui NAO funciona: para telas de iframe ele apenas faz
 * setScrIframe(url), que troca o src do iframe da tela ATUAL. Fora de uma rota
 * /iframe nao existe iframe montado para receber, entao o departamento era
 * selecionado e nada abria -- exatamente o sintoma de "seleciona mas nao
 * clica".
 *
 * O par (cod_departamento, cod_submenu) vem do backend, da mesma consulta que
 * ja filtra o escopo do usuario, entao um cartao nunca aponta para tela fora do
 * que o usuario pode acessar. Se ainda assim a rota nao resolver, o Iframe.jsx
 * redireciona para /home por conta propria.
 */
const useListaTelasHook = ({ aoNavegar }) => {
  const navigate = useNavigate();
  const [abrindo, setAbrindo] = useState(null);

  // navigate e aoNavegar mudam de referencia entre renders; o ref mantem o
  // useCallback estavel para os cartoes nao remontarem durante o streaming.
  const acoesRef = useRef({ navigate, aoNavegar });
  acoesRef.current = { navigate, aoNavegar };

  const abrirTela = useCallback(tela => {
    const { cod_submenu: codSubmenu, cod_departamento: codDepartamento } = tela;

    if (!codSubmenu || !codDepartamento) {
      return;
    }

    setAbrindo(codSubmenu);

    try {
      // So a rota: o Iframe.jsx repassa o departamento para navegarTela, que
      // seleciona a aba e grava a sessao. Setar o departamento aqui tambem
      // dispararia a carga de menus antes da rota trocar, sem necessidade.
      acoesRef.current.navigate(
        `/iframe/${encodeBase64UrlSafe(codDepartamento)}/${encodeBase64UrlSafe(codSubmenu)}`
      );

      acoesRef.current.aoNavegar?.();
    } finally {
      // A rota ja mudou; sem isto o botao ficaria girando ate o proximo render.
      setAbrindo(null);
    }
  }, []);

  return { abrirTela, abrindo };
};

export default useListaTelasHook;
